import React from "react";
import "./Celebrations.css";

const Celebrations = () => {
  return (
    <div className="relative">
      <h1 className="text-2xl font-normal underline text-center">
        You have completed the Survey!
      </h1>
      <div className="fireworks" style={{ left: "-15%", top: "-100px" }}></div>
      <div
        className="fireworks"
        style={{ right: "10%", top: "-100px", animationDelay: " -1.1s" }}
      ></div>
      <div
        className="fireworks"
        style={{ left: "-25%", top: "-100px", animationDelay: "-3.2s" }}
      ></div>
      <div
        className="fireworks"
        style={{ right: "45%", top: "-100px", animationDelay: " -4.3s" }}
      ></div>
      <div
        className="fireworks"
        style={{ left: "-3%", top: "-90px", animationDelay: " -6.4s" }}
      />
      <div
        className="fireworks"
        style={{ right: "35%", top: "-80px", animationDelay: " -7.5s" }}
      />
      <div
        className="fireworks"
        style={{ left: "15%", top: "-50px", animationDelay: "-9.6s" }}
      />
      <div
        className="fireworks"
        style={{ left: "-200px", top: "-120px", animationDelay: "-15.9s" }}
      />
      {/* <div
       <div
         className="fireworks"
         style={{ right: "20%", top: "-120px", animationDelay: " -10.7s" }}
       />
        className="fireworks"
        style={{ left: "20px", top: "-190px", animationDelay: " -12.8s" }}
      />
      <div
        className="fireworks"
        style={{ right: "30px", top: "-200px", animationDelay: " -13.6s" }}
      />
      
      <div
        className="fireworks"
        style={{ right: "210px", top: "-20px", animationDelay: " -16.4s" }}
      /> */}
      {/* <div className="fireworks">
        <div className="firework">
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
        </div>
        <div className="firework" style={{ marginTop: "-70px" }}>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
        </div>
        <div className="firework">
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
        </div>
        <div className="firework" style={{ marginTop: "70px" }}>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
        </div>
        <div className="firework">
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
        </div>
        <div className="firework" style={{ marginTop: "-70px" }}>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
          <div className="explosion">
            <div className="spark silver"></div>
          </div>
        </div>
        <div className="firework">
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
          <div className="explosion">
            <div className="spark gold"></div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Celebrations;
